import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { categoryIcons } from '@/lib/helpers';

export const CategoryTile = ({ category, compact = false }) => {
  const iconName = categoryIcons[category.slug] || 'Sparkle';
  const Icon = Icons[iconName] || Icons.Sparkle;
  if (compact) {
    return (
      <Link
        to={`/search?category=${category.slug}`}
        data-testid={`home-category-tile-${category.slug}`}
        className="flex items-center gap-2 px-3 py-2 rounded-full bg-[#EAF3FF] border border-[#C7E2FF] text-[#0E3F80] text-sm font-medium hover:bg-[#DCEBFF]"
      >
        <Icon size={14} /> {category.label}
      </Link>
    );
  }
  return (
    <Link
      to={`/search?category=${category.slug}`}
      data-testid={`home-category-tile-${category.slug}`}
      className="group flex flex-col items-center justify-center gap-2 p-4 rounded-[var(--radius)] bg-white border border-[#E2E8F0] hover:border-[#C7E2FF] hover:shadow-[0_10px_24px_rgba(11,18,32,0.08)] active:scale-[0.98]"
    >
      <div className="h-11 w-11 rounded-full bg-[#EAF3FF] flex items-center justify-center text-[#1677F2] group-hover:bg-[#C7E2FF]">
        <Icon size={20} />
      </div>
      <span className="text-xs font-semibold text-[#0B1220] text-center leading-tight">{category.label}</span>
    </Link>
  );
};
